import { CAMERA_PRESENTER } from '@studio/constants/Sources';
import setMultipleDesiredAttendeeCameraStatuses from 'actions/Broadcast/attendees/setMultipleDesiredAttendeeCameraStatuses';
import { shouldHaveFeature } from '@studio/feature.flags/featureFlags';
import { VENDOR_AGORA } from '@studio/constants/Vendor';
import setMultipleAttendeeCameraStatuses from '@shoflo/studio-redux/actions/attendee/setMultipleAttendeeCameraStatuses';

/**
 * Builds a map of attendee camera statuses from the current program layers and dispatches
 * the appropriate bulk update action based on vendor.
 *
 * Only layers whose source type is {@link CAMERA_PRESENTER} are considered; each such layer
 * contributes an entry keyed by `source.value` (attendeeId) with the value of `layer.isCameraOn`.
 *
 * @param {Array<{layer: {isCameraOn?: boolean}, source: {type: string, value: string}}>} layers
 *   Program layers to derive camera status from.
 * @returns {(dispatch: Function) => void}
 *   Redux thunk that dispatches a vendor-specific bulk camera status update.
 */
const setCameraStatusFromProgramLayers = layers => {
  return dispatch => {
    const cameraStatuses = {};
    layers.forEach(({ layer, source }) => {
      if (source.type !== CAMERA_PRESENTER) return;
      cameraStatuses[source.value] = layer.isCameraOn;
    });

    const useAgora = shouldHaveFeature('studio.meetingVendor') === VENDOR_AGORA;
    if (useAgora) {
      dispatch(setMultipleAttendeeCameraStatuses(cameraStatuses));
    } else {
      dispatch(setMultipleDesiredAttendeeCameraStatuses(cameraStatuses));
    }
  };
};

export default setCameraStatusFromProgramLayers;
